import type { ParsedUrlQuery } from "querystring";

const toStringQueryParams = (
  query?: ParsedUrlQuery
): Record<string, string> => {
  if (!query) {
    return {};
  }

  return Object.entries(query).reduce<Record<string, string>>(
    (acc, [key, value]) => {
      if (typeof value === "string" && value) {
        acc[key] = value;
      } else if (
        Array.isArray(value) &&
        typeof value[0] === "string" &&
        value[0]
      ) {
        acc[key] = value[0];
      }
      return acc;
    },
    {}
  );
};

/**
 * Builds query params for order-details-v2 navigation.
 * Forwards the current page query (e.g. partnerBookingId, hdr, cmp) and
 * ensures bookingId is set from the normalized cancellation payload.
 */
export const buildOrderDetailsNavigationParams = (
  bookingId: string,
  query?: ParsedUrlQuery
): Record<string, string> => {
  const fromQuery = toStringQueryParams(query);

  return {
    ...fromQuery,
    ...(bookingId ? { bookingId } : {}),
  };
};
